const typographyFormParamEquipService = {
  text: 'Servicios del Equipo',
  text1: 'Seleccione un sitio',
  inactive: 'Desactivado',
};

export default typographyFormParamEquipService;
